import React, { useState, useEffect, useRef } from "react";
import CustomButton from "./CustomButton";
// import { fetchContent } from "../services/api";
import LoginOTP from "./LoginOTP";
import OtpScreen from "./OtpScreen";
import { Translate, Languages } from "./LanguageChanger";
import NumericKeyboard from "./NumericKeyboard";
import { userLoginSignup } from "../services/services";
import editIcon from "../assets/edit.png";
import editIconColor from "../assets/edit-color.png";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";

let resolution = window.RESOLUTION;
let selectedElementIndx = "";

let isRefferalSelected = false;

const LoginPage = ({
  navigate,
  handleLeft,
  loginData,
  isExpired,
  handleRefferal,
  handleCancel,
  referralSuccess,
  isOtpSelected,
}) => {
  const lang = localStorage.getItem("AppLanguage");
  const [selectedLanguage, setSelectedLanguage] = useState(lang);
  const [isOtpScreen, setIsOtpScreen] = useState(false);
  const [isLoginScreen, setIsLoginScreen] = useState(true);
  const [country, setCountry] = useState({ inputValue: "", countryCode: "91" });

  const [state, setState] = useState({
    isMobileSelected: true,
    isEmailSelected: false,
    isproceedSelected: false,
    isSkipLoginSelected: false,
    isMobileNoSelected: false,
    isEmailidSelected: false,
    isNumericKeyboardSelected: false,
    isNumericKeyboardOver: false,
    isDonePressed: false,
    shouldShowError: false,
    // isRefferalSelected:false,
    selectedElementIndxNumeric: "",
    isMobile: true,
    isEmail: false,
    isRefferalFocus: false,
    errTitle: "",
    userLoginData: "",
    inputValue: "", // To store the API response value for the input
    errorMessage: "", // To store the error message
    errDescription: "",
    errIcon: "",
    button: ["Logout", "Cancel"],
    iconWdth: "",
    iconHeight: "",
  });
  const {
    isMobileSelected,
    isEmailSelected,
    isproceedSelected,
    isSkipLoginSelected,
    isMobileNoSelected,
    isEmailidSelected,
    isDonePressed,
    isEmail,
    isMobile,
    errorMessage,
    // isRefferalSelected,
    isRefferalFocus,
    isNumericKeyboardSelected,
    shouldShowError,
    errTitle,
    errDescription,
    errIcon,
    button,
    iconWdth,
    iconHeight,
  } = state;

  console.log("state....", isRefferalSelected);

  const refferalRef = useRef();

  useEffect(() => {
    localStorage.removeItem("NewmobileNo")
  }, [isMobileSelected,]);

  const navigateToScreen = (screen = {}) => {
    navigate(screen);
  };

  console.log("isproceedSelected...", handleCancel);

  useEffect(() => {
    if (window.isRefferalFocus) {
      setTimeout(() => {
        isRefferalSelected = true;
        setState((prevState) => ({
          ...prevState,
          isproceedSelected: false,
          isEmailSelected: false,
          // isRefferalSelected:true,
          isMobile: true,
          isEmail: false,
          shouldShowError: false,
          isNumericKeyboardSelected: false,
        }));
      }, 100);
    } else {
      console.log("Testing hereeeeee");
      setState((prevState) => ({
        ...prevState,
        isproceedSelected: false,
        isEmailSelected: false,
        // isRefferalSelected:true,
        // isMobile: false,
        isMobileSelected: true,
        isEmail: false,
        shouldShowError: false,
        // isNumericKeyboardSelected: true,
      }));
    }
  }, [window.isRefferalFocus, window.isRefferalSelected]);

  // const handleCancel = () => {
  //   console.log("modalCANCELButtonHandler...");
  //     // MenuScreen.ReseTfocus(5);
  //     // MenuScreen.ReseTfocus(-1);
  //     setState((prevState) => ({
  //       ...prevState,
  //       shouldShowError: false,
  //       // isMobile: true,
  //     }));
  //     refferalRef.current?.focus();
  //   };

  const manageFocus = () => {
    refferalRef.current?.focus();
  };
  // console.log("loginData....", loginData);

  localStorage.setItem("isEmail", state.isEmail);
  localStorage.setItem("isMobile", state.isMobile);
  const mobileInputRef = useRef(null);
  const emailInputRef = useRef(null);
  const countryInputRef = useRef(null);
  const IsMobile = localStorage.getItem("isMobile");
  const IsEmail = localStorage.getItem("isEmail");
  console.log("besetttttt", IsEmail, IsMobile)
  useEffect(() => {
    if (isproceedSelected) {
      selectedElementIndx = "1";
    }
  }, [isproceedSelected]);

  console.log("checkProceed", isExpired);

  const LoginPageKeyHandler = (event) => {
    const ScreenName = localStorage.getItem("LoginScreen");
    console.log(
      "ScreenName...",
      ScreenName,
      isRefferalSelected,
      shouldShowError
    );
    // Check if we should block key handling (except for exit/return keys)
    const shouldBlockKeys = shouldShowError;
    const isExitKey = event.keyCode === 461 || event.keyCode === 10009;
    if (event.keyCode !== undefined) {
      if (window.isRefferalSelected && !isRefferalFocus) {
        return;
      }
      switch (event.keyCode) {
        case 13: // OK/Enter key press
          console.log("selectedElementIndx...", state, selectedElementIndx);
          if (ScreenName === "LoginPage") {
            // setState((prevState) => {
            //   let newState = { ...prevState };
            if (selectedElementIndx === "0") {
              console.log("selectedElementIndx...", selectedElementIndx);
              navigate("HomePage", {});
              selectedElementIndx = "";
            } else if (
              state.selectedElementIndxNumeric === "1" ||
              selectedElementIndx === "1"
            ) {
              const mobileNo = localStorage.getItem("mobileNo");
              const email = localStorage.getItem("mobileNo");

              // Basic validation logic
              const isMobileNumberValid =
                mobileNo && /^[6-9][0-9]{9}$/.test(mobileNo);
              const isEmailValid =
                email &&
                /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(
                  email
                );

              let errorMessage = "";

              if (localStorage.getItem("isMobile") === "true") {
                if (!mobileNo) {
                  errorMessage = "Please enter a valid mobile number";
                } else if (mobileNo && !isMobileNumberValid) {
                  errorMessage = "Please enter a valid mobile number.";
                }
              } else if (localStorage.getItem("isEmail") === "true") {
                if (!email) {
                  // console.log("email.1111111111111111...........");
                  errorMessage = "Please enter a valid email address";
                } else if (!isEmailValid) {
                  // console.log("2222222222emeail..............", isEmailValid, email);
                  errorMessage = "Please enter a valid email address.";
                }
              }

              if (errorMessage) {
                setState((prevState) => ({
                  ...prevState,
                  errorMessage,
                }));

                // Clear the error message after 10 seconds
                setTimeout(() => {
                  setState((prevState) => ({
                    ...prevState,
                    errorMessage: "",
                  }));
                }, 10000);
              } else {
                // Input is valid, proceed with loading data
                loadData();
                selectedElementIndx = "";
              }
            }
            console.log(
              "selectedElementIndx",
              selectedElementIndx,
              isRefferalSelected
            );
            if (
              (selectedElementIndx === "2" || isRefferalSelected) &&
              isMobile
            ) {
              // refferalRef.current.blur();
              // handleRefferal();
              isRefferalSelected = false;
              setState((prevState) => {
                let newState = { ...prevState };
                newState.isproceedSelected = false;
                newState.isSkipLoginSelected = false;
                newState.isEmailSelected = false;
                newState.isMobile = true;
                // newState.isRefferalSelected = false;
                newState.isEmail = false;
                newState.shouldShowError = true;
                newState.isNumericKeyboardSelected = false;
                return newState;
              });

              window.isRefferalFocus = false;
              handleBlur(event);
              // if(!referralSuccess)
              handleRefferal();
              // selectedElementIndx = "";
              // handleRefferal();
            } else if (
              (selectedElementIndx === "2" || isRefferalSelected) &&
              isEmail
            ) {
              // refferalRef.current.blur();
              // handleRefferal();
              isRefferalSelected = false;
              setState((prevState) => {
                let newState = { ...prevState };
                newState.isproceedSelected = false;
                newState.isSkipLoginSelected = false;
                newState.isEmailSelected = false;
                newState.isMobile = false;
                // newState.isRefferalSelected = false;
                newState.isEmail = true;
                newState.shouldShowError = true;
                newState.isNumericKeyboardSelected = false;
                return newState;
              });

              window.isRefferalFocus = false;
              // if(!referralSuccess)
              handleBlur(event);
              handleRefferal();
              //  // selectedElementIndx = "1";
              // // handleRefferal();
            }
          }
          break;

        case 39: // right
          // console.log("country...", country.countryCode);
          if (ScreenName === "LoginPage") {
            if (countryInputRef.current) {
              countryInputRef.current.blur(); // First blur the mobile input
            }
            // if (mobileInputRef.current) {
            //   mobileInputRef.current.focus(); // Then focus on the country input
            // }
            if (state.inputValue !== "") state.inputValue = "";
            setState((prevState) => ({
              ...prevState,
              errorMessage: errorMessage ? errorMessage : "",
            }));
            setState((prevState) => {
              let newState = { ...prevState };

              if (prevState.isMobileSelected) {
                newState.isMobileSelected = false;
                newState.isMobile = false;
                newState.isNumericKeyboardSelected = false;
                newState.isEmail = true;
                newState.isEmailSelected = true;
                if (state.inputValue !== "") state.inputValue = "";
                // handleBlur(event); // Ensure this function is executed correctly.
              }
              // else if (prevState.isproceedSelected) {
              //   newState.isproceedSelected = false;
              //   newState.isSkipLoginSelected = true;
              //   newState.isNumericKeyboardSelected = false;
              //   selectedElementIndx = "0";
              // }

              return newState; // This was missing, ensuring the updated state is returned.
            });
            selectedElementIndx = "";
            // if(!isMobile) state.inputValue = "";
            // else
            // if(state.inputValue !== "") state.inputValue = "";
          }
          break;
        case 37: // left
          console.log("first", loginData, isMobileSelected, isEmailSelected);

          if (ScreenName === "LoginPage") {
            if (mobileInputRef.current) {
              mobileInputRef.current.blur(); // First blur the mobile input
            }
            if (countryInputRef.current) {
              // console.log("aslkdfja;ljfladsk.........");
              countryInputRef.current.focus(); // Then focus on the country input
            }
            if (state.inputValue !== "") state.inputValue = "";
            setState((prevState) => ({
              ...prevState,
              errorMessage: errorMessage ? errorMessage : "",
            }));

            setState((prevState) => {
              let newState = { ...prevState };
              console.log("CheckProceed", prevState.isMobileSelected);
              if (prevState.isMobileSelected && isExpired) {
                handleLeft();
                newState.isMobileSelected = false;
              }

              if (prevState.isEmailSelected) {
                newState.isMobileSelected = true;
                newState.isNumericKeyboardSelected = false;
                newState.isMobile = true;
                newState.isEmail = false;
                newState.isEmailSelected = false;
                // handleBlur(event); // Ensure this function is executed correctly.
              } else if (prevState.isSkipLoginSelected) {
                newState.isSkipLoginSelected = false;
                newState.isproceedSelected = true;
                selectedElementIndx = "1";
              }

              return newState; // This was missing, ensuring the updated state is returned.
            });
            // setState(() => ({
            //   isMobile: true,
            //   isEmail: false,
            //   isMobileSelected: true,
            //   isEmailSelected: false,
            // }));
            selectedElementIndx = "";
            // if(state.inputValue !== "") state.inputValue = "";
            // if(isMobile) state.inputValue = "";
            // else if(!isEmail) state.inputValue = "";
            return state;
          }
          break;

        case 38: // Up
          if (ScreenName === "LoginPage") {
            setState((prevState) => {
              let newState = { ...prevState };

              // if(window.isRefferalFocus){
              //   window.isRefferalFocus = false;
              //   window.isRefferalSelected = false;
              //   newState.isproceedSelected = false;
              // }

              if (prevState.isMobileNoSelected) {
                newState.isMobileNoSelected = false;
                newState.isMobileSelected = true;
                handleBlur(event);
              } else if (prevState.isproceedSelected) {
                newState.isproceedSelected = false;
                newState.isNumericKeyboardSelected = true;
                // if (newState.isMobile) newState.isMobileNoSelected = true;
                // else newState.isEmailidSelected = true;
                if (!newState.isMobile) newState.isEmailidSelected = true;
                // else newState.isMobileNoSelected = true;
              } else if (prevState.isSkipLoginSelected) {
                newState.isSkipLoginSelected = false;
                newState.isNumericKeyboardSelected = true;
                // if (newState.isMobile) newState.isMobileNoSelected = true;
                // else newState.isEmailidSelected = true;
                if (!newState.isMobile) newState.isEmailidSelected = true;
                // else newState.isMobileNoSelected = true;
              } else if (prevState.isEmailidSelected) {
                newState.isEmailidSelected = false;
                newState.isEmailSelected = true;
                handleBlur(event);
              } else if (refferalRef.current && prevState.isMobile) {
                newState.isproceedSelected = true;
                newState.isEmailSelected = false;
                newState.isMobile = true;
                newState.isEmail = false;
                //  refferalRef.current.blur();
                // selectedElementIndx = "1";
                // handleBlur(event);
              } else if (isRefferalSelected && prevState.isMobile) {
                isRefferalSelected = false;
                // newState.isRefferalSelected = false;

                newState.isproceedSelected = true;
                newState.isEmailSelected = false;
                newState.isMobile = true;
                newState.isEmail = false;
                //// refferalRef.current.blur();
                // // selectedElementIndx = "1";
                // // handleBlur(event);
              } else if (isRefferalSelected && prevState.isEmail) {
                isRefferalSelected = false;
                // newState.isRefferalSelected = false;

                newState.isproceedSelected = true;
                newState.isEmailSelected = false;
                newState.isMobile = false;
                newState.isEmail = true;
                // // refferalRef.current.blur();
                // // selectedElementIndx = "1";
                //  // handleBlur(event);
              }
              return newState;
            });
            selectedElementIndx = 0;
          }
          break;

        case 40: // down
          // if(window.isRefferalSelected === true){
          //       break;
          //     }

          console.log("selectedElementIndx...", isRefferalSelected);

          if (ScreenName === "LoginPage") {
            setState((prevState) => {
              let newState = { ...prevState };

              if (prevState.isMobileSelected) {
                newState.isMobileSelected = false;
                // newState.isMobile = true;
                // newState.isMobileNoSelected = true;
                newState.isEmail = false;
                newState.isNumericKeyboardSelected = true;
              } else if (prevState.isMobileNoSelected) {
                newState.isMobileNoSelected = false;
                newState.isproceedSelected = true;
                newState.isMobile = true;
                newState.isEmail = false;
                selectedElementIndx = "1";
                handleBlur(event);
              } else if (prevState.isEmailSelected) {
                newState.isMobile = false;
                newState.isEmail = true;
                newState.isEmailSelected = false;
                newState.isEmailidSelected = true;
                selectedElementIndx = "1";
              } else if (prevState.isEmailidSelected) {
                newState.isEmailidSelected = false;
                newState.isMobile = false;
                newState.isEmail = true;
                newState.isproceedSelected = true;
                selectedElementIndx = "1";
                handleBlur(event);
              } else if (prevState.isNumericKeyboardOver) {
                selectedElementIndx = "1";
              } else if (prevState.isproceedSelected && prevState.isMobile) {
                selectedElementIndx = "2";
                newState.isproceedSelected = false;
                newState.isMobile = true;
                newState.isEmail = false;
                newState.isRefferalFocus = true;
                // newState.isRefferalSelected = true;
                isRefferalSelected = true;
                // selectedElementIndx = "2";
                // refferalRef.current.focus();
                // handleBlur(event);
              } else if (prevState.isSkipLoginSelected && prevState.isMobile) {
                selectedElementIndx = "2";
                newState.isSkipLoginSelected = false;
                newState.isMobile = true;
                newState.isEmail = false;
                newState.isRefferalFocus = true;
                // newState.isRefferalSelected = true;
                isRefferalSelected = true;
                // refferalRef.current.focus();
                // handleBlur(event);
              } else if (prevState.isproceedSelected && prevState.isEmail) {
                selectedElementIndx = "2";
                newState.isproceedSelected = false;
                newState.isMobile = false;
                newState.isEmail = true;
                newState.isRefferalFocus = true;
                // newState.isRefferalSelected = true;
                isRefferalSelected = true;
                // selectedElementIndx = "2";
                // refferalRef.current.focus();
                // handleBlur(event);
              } else if (prevState.isSkipLoginSelected && prevState.isEmail) {
                selectedElementIndx = "2";
                newState.isSkipLoginSelected = false;
                newState.isMobile = false;
                newState.isEmail = true;
                newState.isRefferalFocus = true;
                // newState.isRefferalSelected = true;
                isRefferalSelected = true;
                // selectedElementIndx = "2";
                // refferalRef.current.focus();
                // handleBlur(event);
              }
              return newState;
            });
            selectedElementIndx = "";
          }
          break;
        case 461: // return key
          if (ScreenName === "LoginPage") {
            if (window.tizen) {
              sendTestMatomoEvent({ eventCategory: `App`, eventAction: "End" });

              window.tizen.application.getCurrentApplication().exit();
            } else {
              sendTestMatomoEvent({ eventCategory: `App`, eventAction: "End" });

              window.close();
            }
          } else if (ScreenName === "OtpPage") {
            setIsOtpScreen(false);
            setIsLoginScreen(true);
            // setState((prevState) => {
            //   let newState = { ...prevState };
            setState({ ...state, inputValue: "" });
            state.isproceedSelected = false;
            state.isMobileSelected = true;
            // });
            localStorage.setItem("LoginScreen", "LoginPage");
          }
          break;
        // case 8: 
        // if (ScreenName === "LoginPage") {
        //   window.close();
        // } else if (ScreenName === "OtpPage") {
        //   setIsOtpScreen(false);
        //   setIsLoginScreen(true);
        //   // setState((prevState) => {
        //   //   let newState = { ...prevState };
        //   setState({ ...state, inputValue: "" });
        //   state.isproceedSelected = false;
        //   state.isMobileSelected = true;
        //   // });
        //   localStorage.setItem("LoginScreen", "LoginPage");
        // }
        // break;
        case 8:
        case 10009:
          if (ScreenName === "LoginPage") {
            if (window.tizen) {
              sendTestMatomoEvent({ eventCategory: `App`, eventAction: "End" });

              window.tizen.application.getCurrentApplication().exit();
            } else {
              sendTestMatomoEvent({ eventCategory: `App`, eventAction: "End" });

              window.close();
            }
          } else if (ScreenName === "OtpPage") {
            setIsOtpScreen(false);
            setIsLoginScreen(true);
            // setState((prevState) => {
            //   let newState = { ...prevState };
            setState({ ...state, inputValue: "" });
            state.isproceedSelected = false;
            state.isMobileSelected = true;
            // });
            localStorage.setItem("LoginScreen", "LoginPage");
          }
          break;
        default:
          break;
      }
    }
  };

  const handleRefferalClick = () => {
    console.log("handleRefferalClick called");
    // if ((selectedElementIndx === "2" || isRefferalSelected) && isMobile) {
    // refferalRef.current.blur();
    // handleRefferal();
    isRefferalSelected = false;
    setState((prevState) => {
      let newState = { ...prevState };
      newState.isproceedSelected = false;
      newState.isSkipLoginSelected = false;
      newState.isEmailSelected = false;
      newState.isMobile = true;
      // newState.isRefferalSelected = false;
      newState.isEmail = false;
      newState.shouldShowError = true;
      newState.isNumericKeyboardSelected = false;
      return newState;
    });

    window.isRefferalFocus = false;
    // handleBlur(event);
    // if(!referralSuccess)
    handleRefferal();
    // selectedElementIndx = "";
    // handleRefferal();

    // } else if ((selectedElementIndx === "2" || isRefferalSelected) && isEmail) {
    //   // refferalRef.current.blur();
    //   // handleRefferal();
    //   isRefferalSelected = false
    //   setState((prevState) => {
    //     let newState = { ...prevState };
    //     newState.isproceedSelected = false;
    //     newState.isSkipLoginSelected = false;
    //     newState.isEmailSelected = false;
    //     newState.isMobile = false;
    //     // newState.isRefferalSelected = false;
    //     newState.isEmail = true;
    //     newState.shouldShowError = true;
    //     newState.isNumericKeyboardSelected = false;
    //     return newState;
    //   });

    //   window.isRefferalFocus = false;
    //   // if(!referralSuccess)
    //   handleBlur(event);
    //   handleRefferal();
    //   // selectedElementIndx = "";
    //   // handleRefferal();
    // }
  };

  const LoginPageKeyRefferal = (event) => {
    const ScreenName = localStorage.getItem("LoginScreen");
    if (event.keyCode !== undefined) {
      switch (event.keyCode) {
        case 13: // OK/Enter key press
          if (ScreenName === "LoginPage") {
            if (refferalRef.current) {
              refferalRef.current.blur();
              handleRefferal();
              setState((prevState) => {
                let newState = { ...prevState };
                newState.isproceedSelected = false;
                newState.isEmailSelected = false;
                newState.isMobile = true;
                newState.isEmail = false;
                newState.shouldShowError = true;
                newState.isNumericKeyboardSelected = false;
                return newState;
              });
            }
          }
          break;
      }
    }
  };

  // const handleRefferal = () => {
  //   setState((prevState) => ({
  //     ...prevState,
  //     shouldCloseMenu: true,
  //     shouldShowError: true,
  //     errTitle: "Exit",
  //     errDescription: "ExitMsg",
  //     // errIcon: logoutIcon,
  //     iconWdth: "109px",
  //     iconHeight: "109px",
  //     button: ["Exit", "Cancel"],
  //   }));
  //   // MenuScreen.SetFocus(true);
  // };

  const data = {
    mobile: state.inputValue,
    country_code: "+91",
    otp: "",
  };

  // const handleEmail = () => {
  //   setState((prevState) => {
  //     let newState = { ...prevState };

  //     if (prevState.isMobileSelected) {
  //       newState.isMobileSelected = false;
  //       newState.isMobile = false;
  //       newState.isNumericKeyboardSelected = false;
  //       newState.isEmail = true;
  //       newState.isEmailSelected = true;
  //       // handleBlur(event); // Ensure this function is executed correctly.
  //     } else if (prevState.isproceedSelected) {
  //       newState.isproceedSelected = false;
  //       newState.isSkipLoginSelected = true;
  //       newState.isNumericKeyboardSelected = false;
  //       selectedElementIndx = "0";
  //     }

  //     return newState; // This was missing, ensuring the updated state is returned.
  //   });
  //   selectedElementIndx = "";
  // };

  // const handleMobile = () => {
  //   setState((prevState) => {
  //     let newState = { ...prevState };

  //     if (prevState.isEmailSelected) {
  //       newState.isMobileSelected = true;
  //       newState.isNumericKeyboardSelected = false;
  //       newState.isMobile = true;
  //       newState.isEmail = false;
  //       newState.isEmailSelected = false;
  //       // handleBlur(event); // Ensure this function is executed correctly.
  //     } else if (prevState.isSkipLoginSelected) {
  //       newState.isSkipLoginSelected = false;
  //       newState.isproceedSelected = true;
  //       selectedElementIndx = "1";
  //     }

  //     return newState; // This was missing, ensuring the updated state is returned.
  //   });
  //   selectedElementIndx = "";
  // };

  const handleEmail = () => {
    setState((prevState) => {
      if (prevState.isEmailSelected && !prevState.isNumericKeyboardSelected) {
        return prevState;
      }
      let newState = { ...prevState };

      newState.isMobileSelected = false;
      newState.isEmailSelected = true;
      newState.isMobile = false;
      newState.isEmail = true;
      newState.isNumericKeyboardSelected = false;

      if (prevState.isMobile) {
        newState.inputValue = "";
      }

      return newState;
    });
    selectedElementIndx = "";
  };

  const handleMobile = () => {
    setState((prevState) => {
      if (prevState.isMobileSelected && !prevState.isNumericKeyboardSelected) {
        return prevState;
      }

      let newState = { ...prevState };

      newState.isMobileSelected = true;
      newState.isEmailSelected = false;
      newState.isMobile = true;
      newState.isEmail = false;
      newState.isNumericKeyboardSelected = false;

      if (prevState.isEmail) {
        newState.inputValue = "";
      }

      return newState;
    });
    selectedElementIndx = "";
  };

  const loginSkip = () => {
    navigate("HomePage", {});
    selectedElementIndx = "";
  };

  const loginProceed = () => {
    const mobileNo = localStorage.getItem("mobileNo");
    const email = localStorage.getItem("mobileNo");

    // Basic validation logic
    const isMobileNumberValid = mobileNo && /^[6-9][0-9]{9}$/.test(mobileNo);
    const isEmailValid =
      email &&
      /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(email);

    let errorMessage = "";

    if (localStorage.getItem("isMobile") === "true") {
      if (!mobileNo) {
        console.log("innnnn")
        errorMessage = "Please enter a valid mobile number";
      } else if (!isMobileNumberValid) {
        errorMessage = "Please enter a valid mobile number.";
      }
    } else if (localStorage.getItem("isEmail") === "true") {
      if (!email) {
        // console.log("email.1111111111111111...........");
        errorMessage = "Please enter a valid email address";
      } else if (!isEmailValid) {
        // console.log("2222222222emeail..............", isEmailValid, email);
        errorMessage = "Please enter a valid email address.";
      }
    }

    if (errorMessage) {
      setState((prevState) => ({
        ...prevState,
        errorMessage,
      }));

      // Clear the error message after 10 seconds
      setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          errorMessage: "",
        }));
      }, 10000);
    } else {
      // Input is valid, proceed with loading data
      loadData();
      selectedElementIndx = "";
    }
  };

  localStorage.setItem("mobileNo", data.mobile);

  const loadData = async () => {
    const myHeaders = {
      Version: localStorage.getItem("version"),

      Deviceid: localStorage.getItem("macAddress"),
      Devicetoken: localStorage.getItem("uuid"),
      Devicemodel: localStorage.getItem("modelCode"),
      "Content-Type": "application/json",
    };

    const raw = {
      ...data,
      mobile: localStorage.getItem("mobileNo"),
      country_code: "+91",
      otp: "",
    };

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(raw),
    };

    const body = JSON.stringify(raw);

    // const [fetchedWatchedList] = await Promise.all([
    //   fetchContent(
    //     "/V1/getWatchList/lastupdated/00000000000/page/1",
    //     "GET",
    //     headers
    //   ),
    // ]);

    // try {
    //   const [response] = await Promise.all([
    //     fetchContent(
    //       "/V1/userLoginSignup",
    //       "POST",
    //       myHeaders,
    //       body,
    //       true
    //       // JSON.stringify(raw),
    //       // requestOptions
    //     ),
    //   ]);

    try {
      const response = await userLoginSignup(JSON.stringify(raw));
      const isEmail = localStorage.getItem("isEmail") === "true";
      const IsEmailValue = localStorage.getItem("mobileNo");
      const IsMobileValue = localStorage.getItem("mobileNo");
      console.log(isEmail, response, "checkingmobileEmail");

      // 1. Event: Select login method
      sendTestMatomoEvent({
        eventCategory: "Login",
        eventAction: "Select",
        eventName: isEmail ? "WithEmailId" : "WithMobileNumber",
        url: "login",
      });

      // 2. Event: Send OTP
      setTimeout(() => {
        sendTestMatomoEvent({
          eventCategory: "Login",
          eventAction: "SendOtp",
          eventName: isEmail ? IsEmailValue : IsMobileValue,
          url: "login",
        });
      }, 100);

      console.log("myHeaderss...", myHeaders, body)

      if (response.status === true) {
        localStorage.setItem("LoginScreen", "OtpPage");
        // <LoginOTP navigate={navigateToScreen} />;
        setState((prevState) => ({
          ...prevState,
          isproceedSelected: false,
        }));

        setIsLoginScreen(false);
        setIsOtpScreen(true);
        localStorage.setItem("NewmobileNo", raw.mobile)

        // navigate("LoginOtpPage", {});
      }

      if (response.success === false) {
        console.log("chekcing11")

        sendTestMatomoEvent({
          eventCategory: "Login",
          eventAction: "ErrorLog ",
          eventName: `(${response.message})/(${localStorage.getItem(
            "mobileNo"
          )})`,
        });
      }
      // if (!response.ok) {
      //   throw new Error(`HTTP error! status: ${response.status}`);
      // }
      // const result = await response.json();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleFocus = (event) => {
    event.target.focus();
  };

  const handleBlur = (event) => {
    event.target.blur(); // Remove focus explicitly
  };

  const handleCountryCodeChange = (e) => {
    const newCountryCode = e.target.value.replace(/\D/g, ""); // Remove non-digit characters

    // Update the country code in the state (limit to 5 digits)
    if (newCountryCode.length <= 5) {
      setState((prevState) => ({
        ...prevState,
        countryCode: newCountryCode,
      }));
    }

    // Show error message if country code is not '91'
    if (newCountryCode && newCountryCode !== "91") {
      setState((prevState) => ({
        ...prevState,
        errorMessage:
          "Only country code '91' is allowed. Please login through your email address!",
      }));

      // Clear the error message after 10 seconds
      setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          errorMessage: "",
        }));
      }, 10000);
    } else {
      // Clear the error message if '91' is entered
      setState((prevState) => ({
        ...prevState,
        errorMessage: "",
      }));
    }
  };

  // const handleCountryCodeChange = (e) => {
  //   const newCountryCode = e.target.value.replace(/\D/g, ''); // Remove non-digit characters

  //   // Update state with the new country code (limit to 5 digits)
  //   if (newCountryCode.length <= 5) {
  //     setState((prevState) => ({
  //       ...prevState,
  //       countryCode: newCountryCode,
  //     }));
  //   }

  //   // Show an error message if the country code is not '91'
  //   if (newCountryCode !== '91') {
  //     setState((prevState) => ({
  //       ...prevState,
  //       errorMessage: "Please login through your email address!",
  //     }));

  //     // Clear the error message after 10 seconds
  //     setTimeout(() => {
  //       setState((prevState) => ({
  //         ...prevState,
  //         errorMessage: "",
  //       }));
  //     }, 10000);
  //   } else {
  //     // Clear the error message if '91' is entered
  //     setState((prevState) => ({
  //       ...prevState,
  //       errorMessage: "",
  //     }));
  //   }
  // };

  useEffect(() => {
    if (!loginData && !isRefferalSelected) {
      window.addEventListener("keydown", LoginPageKeyHandler);
      setState((prevState) => ({
        ...prevState,
        isMobileSelected: true,
        // isMobileNoSelected: false,
        // isMobile:false,
        // isEmailSelected: true,
        // isEmailidSelected: false,
        // isMobile: false,
        // isEmail: true,
      }));
    }
    return () => {
      window.removeEventListener("keydown", LoginPageKeyHandler);
    };
    //  }, [loginData]);
  }, [loginData]);
  useEffect(() => {
    if (!loginData && !isRefferalSelected) {
      window.addEventListener("keydown", LoginPageKeyHandler);
    }
    return () => {
      window.removeEventListener("keydown", LoginPageKeyHandler);
    };
    //  }, [loginData]);
  }, [loginData, isExpired]);

  useEffect(() => {
    console.log("Login page.....");
    if (isMobileNoSelected) {
      mobileInputRef.current?.focus();
    } else if (isEmailidSelected) {
      emailInputRef.current?.focus();
    }
  }, [isMobileNoSelected, isEmailidSelected]);

  //  useEffect(() => {
  //     // Update isFocus based on loginData
  //     setState((prevState) => ({
  //       ...prevState,
  //       isMobile: true,
  //       isMobileSelected:true,
  //     }));
  //     // setIsFocus(loginData);
  //   }, [loginData]);

  // useEffect(() => {
  //   if (state?.inputValue?.length >= 10) {
  //     setState((prevState) => {
  //       let newState = { ...prevState };
  //       // console.log("prevState.isMobileSelected",prevState.isMobileSelected)
  //     if (prevState.isMobileNoSelected) {
  //         newState.isMobileNoSelected = false;
  //         newState.isproceedSelected = true;
  //         newState.isMobile = true;
  //         newState.isEmail = false;
  //         selectedElementIndx = "1";
  //       }
  //       return newState;
  //     });
  //     selectedElementIndx = "";
  //   }else{
  //     setState((prevState) => {
  //       let newState = { ...prevState };
  //         newState.isMobileNoSelected = true;
  //         newState.isproceedSelected = false;
  //         newState.isMobile = true;
  //         newState.isEmail = false;
  //         selectedElementIndx = "1";
  //       return newState;
  //     });
  //     selectedElementIndx = "";
  //   }
  // }, [state.inputValue])

  const getTranslation = (key) => {
    return Languages[selectedLanguage]?.[key] || Languages.English[key];
  };

  const selectedLangauge = localStorage.getItem("AppLanguage");

  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // height: "65%",
    // backgroundColor: "#000037",
    // backgroundColor: "#000",
    // width: "90%",
    margin: "0px",
    gap: "1rem",
  };

  const cardStyle = {
    padding: "0px",
    borderRadius: "10px",
    textAlign: "center",
    // width: "80%",
    height: "100%",
    boxSizing: "border-box",
    marginTop: "11%",
  };

  const titleStyle = {
    fontFamily: "Anek Latin",
    fontWeight: 700,
    fontSize:
      selectedLangauge === "Malayalam" ||
        selectedLangauge === "Tamil" ||
        selectedLangauge === "Telugu" ||
        selectedLangauge === "canada"
        ? "1.78125rem"
        : "2.375rem",
    color: "rgba(255, 255, 255, 1)",
    marginBottom: "10px",
  };

  const subtitleStyle = {
    fontFamily: "Anek Latin",
    fontWeight: 400,
    fontSize:
      selectedLangauge === "Malayalam" ||
        selectedLangauge === "Tamil" ||
        selectedLangauge === "Telugu" ||
        selectedLangauge === "Kannada"
        ? "1.2rem"
        : "1.87rem",
    color: "rgba(255, 255, 255, 1)",
    marginBottom: "21px",
  };

  const tabContainerStyle = {
    fontFamily: "Anek Latin",
    fontWeight: 500,
    display: "flex",
    justifyContent: "center",
    marginBottom: "20px",
    gap: "2rem",
  };

  const inputContainerStyle = {
    // display: "flex",
    // alignItems: "left",
    marginTop: "2rem",
    // width: "22rem",
  };

  const errorMessageStyle = {
    color: "red",
    marginBottom: "10px",
    marginTop: "20px",
  };

  const countrySelectorStyle = {
    display: "flex",
    alignItems: "center",
    padding: "10px",
    border: "1px solid #444",
    borderRadius: "5px 0 0 5px",
    backgroundColor: "#0E1653",
    width: "5rem",
    height: "3rem",
  };

  const flagStyle = {
    width: "20px",
    marginRight: "10px",
  };

  const countryCodeStyle = {
    backgroundColor: "#0E1653",
    color: "#fff",
    width: "5rem",
    height: "4rem",
    border: "none",
  };

  const inputStyle = {
    flex: 1,
    padding: "10px",
    border: "1px solid #fff",
    borderRadius: "0 5px 5px 0",
    backgroundColor: "#0E1653",
    color: "#FFF",
    width: "20rem",
    height: "3rem",
    cursor: "pointer",
    outline: "none"

  };

  const emailInputStyle = {
    ...inputStyle,
    padding: "0px 0px 0px 12px",
    fontSize: "1.125rem",
    borderRadius: "16px 16px 16px 16px",
    width: "25.0625rem",
    height: "60px",
    // marginTop: "4vh",
    cursor: "pointer",
    outline:"none"
  };

  const conditionemailStyle = {
    // flex: 1,
    padding: "0px 0px 0px 12px",
    border: "1px solid #444",
    borderRadius: "16px 16px 16px 16px",
    backgroundColor: "#0E1653",
    color: "#FFF",
    height: "60px",
    width: "20.83vw",
    // marginTop: "6rem",
    cursor: "none",

  };


  const infoStyle = {
    fontFamily: "Anek Latin",
    fontWeight: "400",
    width: "293",
    height: "20",
    fontSize: "1.125rem",
    color: "rgba(137, 137, 137, 1)",
    marginBottom: "20px",
  };

  const footerTextStyle = {
    fontFamily: "Anek Latin",
    fontWeight: 500,
    color: "rgba(151, 151, 151, 1)",
    position: "relative",
    top: "19vh",
    fontSize: "20px",
  };

  const linkStyle = {
    color: "#FF6F00",
    textDecoration: "none",
  };

  const buttonContainer = {
    fontFamily: "Anek Latin",
    fontWeight: 600,
    color: "rgba(255, 255, 255, 1)",
  };

  const conditionStyle = {
    flex: 1,
    padding: "10px",
    border: "1px solid rgba(255, 255, 255, 0.4)",
    borderRadius: "0 5px 5px 0",
    backgroundColor: "#0E1653",
    color: "#FFF",
    width: "20rem",
    marginLeft: "1rem",
    height: "3rem",
    cursor: "none",
  };

  // useEffect(() => {
  //   // Register numeric keys for the remote control
  //   if (typeof window.tizen !== "undefined" && window.tizen.tvinputdevice) {
  //     window.tizen.tvinputdevice.registerKeyBatch(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]);
  //   }

  //   // Set the keyboard layout to numeric when the component mounts
  //   const setKeyboardLayout = () => {
  //     if (typeof window.tizen !== "undefined" && window.tizen.inputdevice) {
  //       window.tizen.inputdevice.setKeyboardLayout("NUMERIC");
  //     }
  //   };

  //   mobileInputRef.current.addEventListener("focus", setKeyboardLayout);

  //   // Cleanup event listener on unmount
  //   return () => {
  //     mobileInputRef.current?.removeEventListener("focus", setKeyboardLayout);
  //   };
  // }, []);

  console.log({
    inputValue: state.inputValue,
  });

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <style>
          {`
              input::placeholder {
                color: rgba(255, 255, 255, 0.4);
                font-size: 20px;
                font-family: 'Anek Latin', sans-serif;
                font-weight: 300;
                gap: 1rem;
              }

              /* Hide the spin buttons in number input fields */
              input[type="number"]::-webkit-inner-spin-button, 
              input[type="number"]::-webkit-outer-spin-button { 
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                margin: 0; 
              }
            `}
        </style>

        {isLoginScreen ? (
          <>
            {/* First Screen */}
            <h1 style={titleStyle}>
              <Translate langKey={"sign_in_with_mobile_or_email"} />
            </h1>
            <p style={subtitleStyle}>
              <Translate
                langKey={"enter_your_mobile_number_or_email_to_continue"}
              />
            </p>
            {/* ... your other components ... */}
            <div style={tabContainerStyle}>
              <CustomButton
                fontSize={resolution === "FHD" ? "24px" : "24px"}
                defaultSelected={isMobileSelected}
                //  width={resolution === "FHD" ? "14vw" : "16vw"}
                height={resolution === "FHD" ? "7vh" : "7vh"}
                top={resolution === "FHD" ? "0vh" : "0vh"}
                // left={resolution === "FHD" ? "0vw" : "0vw"}
                right={resolution === "FHD" ? "0vw" : "0vw"}
                border={isMobile ? "2.5px solid #EC008C" : "none"}
                onClick={handleMobile}
                onMouseEnter={handleMobile}
                style={{
                  width: resolution === "FHD" ? "14vw" : "16vw",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              // style={{
              //   border: isMobileSelected
              //     ? "2px solid red!important"
              //     : "2px solid red", // Apply red border if selected, transparent otherwise
              // }}
              >
                <Translate langKey={"Phone-Number"} />
              </CustomButton>
              <CustomButton
                fontSize={resolution === "FHD" ? "24px" : "24px"}
                defaultSelected={isEmailSelected}
                // width={resolution === "FHD" ? "14vw" : "16vw"}
                height={resolution === "FHD" ? "7vh" : "7vh"}
                // top={resolution === "FHD" ? "85vh" : "85vh"}
                //  left={resolution === "FHD" ? "14vw" : "16vw"}
                right={resolution === "FHD" ? "0vw" : "0vw"}
                border={isEmail ? "2.5px solid #EC008C" : "none"}
                style={{
                  width: resolution === "FHD" ? "14vw" : "16vw",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={handleEmail}
                onMouseEnter={handleEmail}
              >
                <Translate langKey={"e-email"} />
              </CustomButton>
            </div>
            {isMobile && (
              <>
                {(!isMobileSelected || isMobileSelected) &&
                  (!isMobileNoSelected || isMobileNoSelected) && (
                    <div style={inputContainerStyle}>
                      {/* <div style={countrySelectorStyle}>
                        <input
                          ref={countryInputRef}
                          type="tel"
                          value={`+${country.countryCode}`}
                          onChange={handleCountryCodeChange}
                          style={countryCodeStyle}
                          maxLength={5} // Allow country code to be max 5 digits
                          placeholder="Country Code"
                        />
                      </div> */}
                      {/* <input
                        type="tel"
                        pattern="[0-9]+" // Use 'tel' to restrict input to numbers on most devices
                        ref={mobileInputRef}
                        id="inputField"
                        value={isMobile ? state.inputValue : ""}
                        maxLength={10} // Ensure the maximum input length is 10 digits
                        // placeholder="Enter your mobile number"
                        // placeholder={<Translate langKey={'enter_mobile_number'}/>}
                        placeholder={`${getTranslation('Enter-Phone-Number')}`}
                        onBlur={handleBlur}

                        onFocus={(e) => {
                          if (!state.isMobile) {
                            setState((prevState) => ({
                              ...prevState,
                              inputValue: "", // Clear any lingering value
                            }));
                          }
                        }}
                        onChange={(e) => {
                          // Allow only digits and prevent input beyond 10 characters
                          const value = e.target.value;
                          if (/^\d*$/.test(value) && value.length <= 10) {
                            setState({ ...state, inputValue: value });
                          }
                        }}
                        style={isMobileNoSelected ? inputStyle : conditionStyle}
                      /> */}

                      <NumericKeyboard
                        state={state}
                        setState={setState}
                        selectedElementIndx={selectedElementIndx}
                      />
                    </div>
                  )}
              </>
            )}
            {isEmail && (
              <>
                {(!isEmailSelected || isEmailSelected) &&
                  (!isEmailidSelected || isEmailidSelected) && (
                    <div
                      style={{
                        display: "block",
                        marginTop: "3rem",
                        marginLeft: "-7.2rem",
                        marginRight: "-6.9rem",
                      }}
                    >
                      <input
                        type="email"
                        id="inputFieldEmail"
                        ref={emailInputRef}
                        value={isEmail ? state.inputValue : ""}
                        maxLength={30}
                        // placeholder="Enter your email address"
                        placeholder={`${getTranslation("acc-enteremail")}`}
                        onBlur={handleBlur}
                        onFocus={(e) => {
                          if (!state.isEmail) {
                            setState((prevState) => ({
                              ...prevState,
                              inputValue: "", // Clear any lingering value
                            }));
                          }
                        }}
                        enable={true}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Update state with the new input value
                          setState({ ...state, inputValue: value });

                          // Regular expression for validating email format
                          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                          // Check if the email matches the regex pattern
                          // if (emailRegex.test(value)) {
                          //   // Email is valid, handle accordingly
                          //   setState({ ...state, inputValue: true, errorMessage: '' });
                          // } else {
                          //   // Email is invalid, handle error state
                          //   setState({ ...state, inputValue: false, errorMessage: 'Invalid email format' });
                          // }
                        }}
                        style={
                          isEmailidSelected
                            ? emailInputStyle
                            : conditionemailStyle
                        }
                      />
                    </div>
                  )}
              </>
            )}
            {errorMessage && (
              <div style={errorMessageStyle}>{errorMessage}</div>
            )}
            {isMobile ? (
              <p style={infoStyle}>
                <Translate langKey={"sms-verify"} />
              </p>
            ) : isEmail ? (
              <p style={infoStyle}>
                <Translate langKey={"email-verify"} />
              </p>
            ) : null}
            {/* <div> */}
            <div
              style={{
                display: "flex",
                // justifyContent: "space-between",
                gap: "1rem",
                width: "100%",
                height: "5rem",
                justifyContent: "center" /* Horizontal center */,
                alignItems: "center",
                // marginLeft: isEmail
                //   ? "2rem"
                //   : localStorage.getItem("AppLanguage") === "Malayalam"
                //   ? "9rem"
                //   : "50px",
              }}
            >

              <CustomButton
                position={"block"}
                navigateTo="/LoginOTP"
                fontSize={resolution === "FHD" ? "24px" : "1.125rem"}
                defaultSelected={
                  isproceedSelected ? "#FF671F" : "rgba(255, 103, 31, 1)"
                }
                border={isproceedSelected ? "4px solid #fff" : "none"}
                // width={resolution === "FHD" ? "26vw" : "12vw"}
                height={resolution === "FHD" ? "7vh" : "5vh"}
                opacity={isproceedSelected ? "" : "0.7"}
                onClick={loginProceed}
                style={{
                  width: resolution === "FHD" ? "25rem" : "11rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onKeyDown={LoginPageKeyHandler}
              >
                <Translate langKey={"proceed"} />
              </CustomButton>
              {/* <CustomButton
                  position={"block"}
                  navigateTo="/homepage"
                  fontSize={resolution === "FHD" ? "24px" : "18px"}
                  defaultSelected={isSkipLoginSelected}
                  width={resolution === "FHD" ? "20vw" : "12vw"}
                  height={resolution === "FHD" ? "9vh" : "7vh"}
                  onClick={loginSkip}
                  onKeyDown={LoginPageKeyHandler}
                >
                  <Translate langKey={"skip_start_browsing"} />
                </CustomButton> */}
            </div>
            {console.log("isRefferalSelected", referralSuccess)}
            <CustomButton
              navigateTo="/homepage"
              fontSize={resolution === "FHD" ? "24px" : "1.125rem"}
              defaultSelected={isRefferalSelected && !referralSuccess}
              ref={refferalRef}
              type="referral-button"
              style={{
                // background: "none",
                border: "none",
                outline: "none",
                position: "relative",
                fontFamily: "Anek Latin",
                fontWeight: 600,
                height: "41",
                width: "188px",
                fontSize: "1.25rem",
                top: "1vh",
                // right :"13vh"

                // color:
                //   document.activeElement === refferalRef.current
                //     ? "#EC008C"
                //     : "rgba(151, 151, 151, 1)",
              }}
              onClick={handleRefferalClick}
              onKeyDown={LoginPageKeyHandler}
              onMouseEnter={(e) => {
                e.target.style.color = "#EC008C";
              }}
              onMouseLeave={(e) => {
                e.target.style.color = "#ffff";
              }}
            >
              {referralSuccess !== null &&
                referralSuccess !== undefined &&
                referralSuccess ? (
                <>
                  Referral Code {localStorage.getItem("refferalCodeNumber")}{" "}
                  Applied Successfully
                  {isRefferalSelected ? 
                   <img
                    src={editIconColor}
                    alt="edit"
                    style={{ width: "2rem", height: "2rem" }}
                  /> : 
                  <img
                    src={editIcon}
                    alt="edit"
                    style={{ width: "2rem", height: "2rem", backgroundColor: "transparent" }}
                  />
}
                </>
              ) : (
                <>
                  <Translate langKey={"have_refferel_code"} />
                </>
              )}


              {/* {referralSuccess !== null && referralSuccess !== undefined && referralSuccess ?`Refferal Code ${localStorage.getItem("refferalCodeNumber")} Applied Successfully` : "Have a referral code?" } */}

              {/* <Translate langKey={"have_refferel_code"} /> */}
            </CustomButton>
            <p
              style={{
                fontFamily: "Anek Latin",
                fontWeight: 400,
                fontSize: "20px",
                color: "rgba(137, 137, 137, 1)",
                // marginBottom: "10px",
                top: "-5px",
                // bottom: "0vh",
                position: "relative",

              }}
            >
              <Translate
                langKey={"Having_Trouble_Logging_in"}
              />
              {/* Having Trouble Logging in? Please visit{" "} */}
              {/* <a href="https://www.xyz.com" style={linkStyle}> */}
              {/* <a href="https://www.xyz.com" style={linkStyle}> */}
              {/* our website */}
              {/* </a> */}
            </p>
            {/* </div> */}
          </>
        ) : (
          isOtpScreen && (
            <>
              <OtpScreen navigate={navigateToScreen}  handleLeft={handleLeft} isOtpSelected={isOtpSelected} isExpired={isExpired} />
            </>
          )
        )}

        {/* <ErrorScreen errorIcon={errorIcon} disply={isError ? "flex" : "none"} /> */}
        {/* <div style={{position: "relative", zIndex:"99"}}>
        <RefferalPopup
          shouldShowError={shouldShowError}
          errTitle={errTitle}
          errDescription={errDescription}
          errIcon={errIcon}
          button={button}
          iconWdth={iconWdth}
          iconHeight={iconHeight}
          // modalOKButtonHandler={modalOKButtonHandler}
          // modalCANCELButtonHandler={modalCANCELButtonHandler}
        />
        </div> */}
      </div>
    </div>
  );
};

export default LoginPage;

// function loadWebapisScript() {
//   return new Promise((resolve, reject) => {
//     if (typeof window.webapis !== "undefined") {
//       resolve(); // `webapis` is already available
//       return;
//     }

//     const script = document.createElement("script");
//     script.src = "$WEBAPIS/webapis/webapis.js";
//     script.type = "text/javascript";
//     script.onload = resolve;
//     script.onerror = reject;
//     document.head.appendChild(script);
//   });
// }
